import * as React from 'react';
import b_ from 'b_';
import { useState } from 'react';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getContent } from '../../../content';
import Popup from '../../../Popup';
import Item from './components/Item';

import './index.scss';

interface Props {
  tabIndex: number;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-results-content-graph');

const Graph: React.FC<Enhanced> = ({ t, tabIndex }) => {
  const { graph, nonClickable } = getContent(t)[tabIndex];

  const [activePopup, setActivePopup] = useState<number | null>(null);

  return (
    <>
      <div className={b()}>
        {graph.map((item, i) => (
          <Item
            key={i}
            index={i}
            tabIndex={tabIndex}
            onGraphColumnClick={!nonClickable ? () => setActivePopup(i) : undefined}
          />
        ))}
      </div>
      {activePopup !== null && (
        <Popup active={activePopup} onClose={() => setActivePopup(null)} tabIndex={tabIndex} />
      )}
    </>
  );
};

export default translate(Graph);
